import request from '@/utils/request'

export function getAll() {
  return request({
    url: '/responseTypes/all',
    method: 'Get'
  })
}
